import { Attribute, Relationship, Resource } from 'json-api';
import { Validable } from 'src/app/core/common-behaviors/validate.mixin';
import { AtomResource } from '../classes/atom-resource';
import { Offer } from './offer.resource';
import { Pack } from './pack.resource';
import { ResourceConfig } from 'src/app/resources/resources-interfaces/resource-config';
import { OfferConfig } from 'src/app/shared/tools/search/search-config';
import { AtomService } from '../atom.service';

const PackofferMixinBase = Validable(AtomResource);
@Resource({
  type: 'packoffers',
})
export class PackOffer extends PackofferMixinBase {
  @Attribute() data?: Record<string, unknown>;
  @Relationship() offer?: Offer;
  @Relationship() pack?: Pack;  @Attribute({ key: 'validity_tz' }) validityTz?: string;
  // @Attribute() validity?: string;

}

export class PackOfferConfig implements ResourceConfig {
  hosted = 'pack';
  tables = {
    columns: [
      {
        columnDef: 'id',
        displayedDatas: [{ path: ['id'], class: 'main' }],
        header: 'ID',
        translatable: false,
        displayed: true,
        sort: 'id',
      },
      {
        columnDef: 'status',
        header: 'Validity',
        displayed: true,
      },
      // {
      //   columnDef: 'name',
      //   header: 'Name',
      //   padisplayedDatas: [{path: ['offer.name']}],
      //   displayed: true,
      // },
      {
        columnDef: 'price',
        header: 'Price',
        displayedDatas: [
          {
            path: ['offer.price'],
            addUnit: {
              path: 'offer.currency.id',
            },
            class: 'mat-title',
          }
        ],
        displayed: true,
      },
      {
        columnDef: 'billingmode',
        header: 'Billing Mode',
        displayed: true,
        displayedDatas: [
          {path: ['offer.billingmode.name']},
          {path: ['offer.recurringperiod.name']}
        ],
      },
      {
        columnDef: 'providers',
        header: 'Providers',
        displayed: true,
        displayedDatas: [
          {path: ['offer.enduserproviderjob.firm.name']},
          {path: ['offer.billingproviderjob.firm.name']}
        ],
      },
      {
        columnDef: 'actions',
        header: 'Actions',
        translatable: false,
        displayed: true,
      },
    ]
  };
  wizard = {
    tabs: [
      {
        title: 'Pack Offer',
        formGroup: 'pakcoffer',
        list: [
          {
            type: 'resource',
            title: 'Offer',
            formControl: 'offer',
            APIKey: 'offer',
            search: new OfferConfig(this.atom),
            required: true,
            noCols: true,
          },
          {
            type: 'validity',
            title: 'Validity',
            formControl: 'validity',
          },
        ]
      }
    ]
  };
  resource = PackOffer;
  resourceName?: string | undefined = 'Pack Offer';
  resourceKey?: string | undefined = 'packoffers';
  resourceKeySingle?: string | undefined = 'packoffer';
  includes?: string[] | undefined = [
    'offer.enduserproviderjob.firm',
    'offer.billingproviderjob.firm',
    'pack'
  ];
  constructor(private atom: AtomService) {}
}
